const RolesEnum = {
	SuperAdmin: 1,
	InfoSecAdmin: 7,
	AccessManager: 8,
	Affiliate: 2,
	Test: 100,
};
export default RolesEnum;
